export const CHANGE_FEEDBACK_FORM = "CHANGE_FEEDBACK_FORM";
export const SEND_FEEDBACK_REQUEST = "SEND_FEEDBACK_REQUEST";
export const SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS";
export const SEND_FEEDBACK_FAILURE = "SEND_FEEDBACK_FAILURE";